module.exports = __webpack_public_path__ + "static/media/signIn.0d8d7bac.svg";